// extracted by mini-css-extract-plugin
export default {"sign_btn":"styles_sign_btn__K-J0l","err_btn":"styles_err_btn__MHi36"};